/** Bound the whole operation, including auth and response decoding, not just fetch. */
export class RequestTimeoutError extends Error {
  constructor() { super('The request took too long. Please try again.'); this.name = 'RequestTimeoutError' }
}
export async function requestDeadline<T>(operation: (signal: AbortSignal) => Promise<T>, timeoutMs = 30000): Promise<T> {
  const controller = new AbortController()
  let timer: ReturnType<typeof setTimeout>
  const timeout = new Promise<never>((_, reject) => {
    timer = setTimeout(() => { controller.abort(); reject(new RequestTimeoutError()) }, timeoutMs)
  })
  try { return await Promise.race([operation(controller.signal), timeout]) }
  finally { clearTimeout(timer!) }
}
